export const config = {
  apiKey: 'AIzaSyAZ-rxpG14BEKA4X28s1wsZnoiI8UyI43k',
  authDomain: 'gunchained-f3adc.firebaseapp.com',
  databaseURL: 'https://gunchained-f3adc.firebaseio.com',
  projectId: 'gunchained-f3adc',
  storageBucket: 'gunchained-f3adc.appspot.com',
  messagingSenderId: '752462549575',
  appId: '1:752462549575:web:f953a9a0b4da6ceced5762',
  measurementId: 'G-9J89C5FV34'
}
